var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "image-input",
      class: { "image-input--ready-to-drop": _vm.flags.isReadyToDrop }
    },
    [
      _vm.imageDataUrl
        ? _c("div", { staticClass: "image-input__image-preview" }, [
            _c("img", { attrs: { src: _vm.imageDataUrl } })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "image-input__input-inner" }, [
        _c("div", { staticClass: "image-input__text" }, [
          _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "notes" },
            _vm._l(_vm.notes, function(note, key) {
              return _c("p", { key: key, staticClass: "image-input__note" }, [
                _vm._v(_vm._s(note))
              ])
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "file", accept: "image/*" },
          on: { change: _vm.handleImageUpload }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5fd91b0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fd91b0c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/common/DEPRECATED.inputs/ImageInput.vue
// module id = +y/h
// module chunks = 1